import { render } from "./Warning.vue?vue&type=template&id=2f4a6838&scoped=true&ts=true"
import script from "./Warning.vue?vue&type=script&lang=ts"
export * from "./Warning.vue?vue&type=script&lang=ts"

import "./Warning.vue?vue&type=style&index=0&id=2f4a6838&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4a6838"]])

export default __exports__